import dayjs from '../../utils/dayjs';
import { DataTable, EmptyState, Layout, Page, Text, Link, Badge, Card } from '@shopify/polaris';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import emptyIMG from '../../media/images/empty.png';
import Pagination from '../../components/pagination';
import helpers from '../../helpers';

import SkeletonLoading from 'components/skeletonPageLoading';
import SimpleFilter from 'components/simpleFilter';
import { ___ } from 'languages/index';
import { TypedVehicle, useGetVehicles } from 'queries/vehicle.query';
import { Helmet } from 'react-helmet-async';
import VehicleModal from './vehicle.modal';
import { PlusIcon, RefreshIcon } from '@shopify/polaris-icons';

export default function VihicleList() {
  const [entities, setEntities] = useState<TypedVehicle[]>([]);
  const [totalItems, setTotalItems] = useState(0);

  const history = useNavigate();

  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  let { search } = useLocation();
  let StringQuery: any = helpers.ExtractUrl(search);

  const initialQuery = {
    query: '',
    page: 1,
    limit: 200,
    sort: 'createdAt:desc',
  };
  const [mainQuery, setMainQuery] = useState({
    ...initialQuery,
    ...StringQuery,
  });

  const { data, refetch: getEntities, isPending: loading } = useGetVehicles(mainQuery);

  useEffect(() => {
    if (data) {
      setEntities(data.body);
      setTotalItems(data.totalItems);
    }
  }, [data]);

  /**
   * Change page number
   */
  const onChangePagination = useCallback(
    (numPage: number, limit: number) => {
      setMainQuery({ ...mainQuery, page: numPage, limit: limit });
    },
    [mainQuery]
  );

  /**
   * Double request!
   */
  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (search !== buildURLSearch) history('/vehicle' + buildURLSearch);
    getEntities();
  }, [mainQuery]);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  const [newModelactive, setNewModelactive] = useState(false);
  const toggleNewActive = useCallback(() => setNewModelactive((active) => !active), []);

  const emptyData = (
    <EmptyState heading="Không có bản ghi!" image={emptyIMG}>
      <p>Oh, Không có gì ở đây. Hãy thử bỏ bộ lọc hoặc tạo mới.</p>
    </EmptyState>
  );

  const renderItem = (vehicle: TypedVehicle) => {
    const {
      id,
      name,
      note,
      license_plate,
      default_driver_data,
      vehicle_imei,
      vehicle_status,
      createdAt,
      sum_of_distance,
      sum_of_income,
      sum_of_trip,
    } = vehicle;
    return [
      id,
      <Link url={`/vehicle/${id}/log`}>
        <div style={{ minWidth: '150px' }}>{license_plate}</div>
      </Link>,
      vehicle_imei || '--',
      default_driver_data ? `${default_driver_data?.display_name}/ ${default_driver_data?.user_phonenumber}` : '-- -- -- -- --',
      <div style={{ minWidth: '150px' }}>{helpers.trimContentString(name)}</div>,
      helpers.formatNumberWithCommas(sum_of_income),
      helpers.formatNumberWithCommas(sum_of_trip),
      helpers.formatNumberWithCommas(sum_of_distance),
      note,
      vehicle_status === 1 ? <Badge tone="success">Hoạt động</Badge> : <Badge tone="warning">Ngừng hoạt động</Badge>,
      createdAt ? dayjs(new Date(Number(createdAt))).format('HH:mm:ss DD-MM-YYYY') : '-',
    ];
  };
  const PagesList =
    entities?.length > 0 ? (
      <>
        <DataTable
          hoverable
          // fixedFirstColumns={2}
          columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text']}
          headings={['ID', 'Biển số', 'IMEI', 'Tài xế', 'Loại xe', 'Doanh thu', 'Tổng chuyến', 'Tổng KM', 'Ghi chú', 'Tình trạng', 'Tạo']}
          rows={entities?.map(renderItem)}
          hideScrollIndicator
          footerContent={___('Show page {display_page_number} of {total_record_number} results', {
            display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
            total_record_number: <Text as="strong">{totalItems}</Text>,
          })}
        />
      </>
    ) : (
      emptyData
    );

  const Actual_page = (
    <>
      <Helmet>
        <title>Danh sách phương tiện</title>
      </Helmet>
      <Page
        fullWidth
        title="Phương tiện"
        titleMetadata={<Badge tone="success-strong">{`${totalItems} phương tiện`}</Badge>}
        primaryAction={{
          content: 'Thêm',
          disabled: false,
          icon: PlusIcon,
          onAction: toggleNewActive,
        }}
        backAction={{
          content: 'Về trang chủ',
          onAction: () => {
            history('/');
          },
        }}
      >
        <Card padding="0">
          <SimpleFilter
            loading={loading}
            onCallback={filterCallback}
            options={[]}
            sortField={[
              {
                label: 'Doanh thu',
                field: 'sum_of_income',
              },
              {
                label: 'Số chuyến',
                field: 'sum_of_trip',
              },
              {
                label: 'Số KM di chuyển',
                field: 'sum_of_distance',
              },
            ]}
          />
          {PagesList}
        </Card>
        <br />
        {totalItems > mainQuery.limit ? (
          <Pagination TotalRecord={totalItems} activeCurrentPage={mainQuery.page} pageSize={mainQuery.limit} onChange={onChangePagination} />
        ) : null}
      </Page>
      {
        <VehicleModal
          show={newModelactive}
          currentVehicleID={null}
          onClose={() => {
            setNewModelactive(false);
          }}
        />
      }
    </>
  );

  return <>{entities === null ? <SkeletonLoading /> : Actual_page}</>;
}

